export default __webpack_public_path__ + "static/media/SeminarioIes2026_EmanuellePerez.2ab0638d.jpg";